const changeViewDropdown = {
  company: {
    body: 'האם הינך בטוח שברצונך להחליף חברה?',
  },
  site: {
    body: 'האם הינך בטוח שברצונך להחליף אתר?',
  },
};

export default changeViewDropdown;
